var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/arrow-up"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5467 6.87996C12.4201 6.87996 12.2934 6.83329 12.1934 6.73329L8.50008 3.03996L4.80674 6.73329C4.61341 6.92663 4.29341 6.92663 4.10008 6.73329C3.90674 6.53996 3.90674 6.21996 4.10008 6.02663L8.14675 1.97996C8.34008 1.78663 8.66008 1.78663 8.85341 1.97996L12.9001 6.02663C13.0934 6.21996 13.0934 6.53996 12.9001 6.73329C12.8067 6.83329 12.6734 6.87996 12.5467 6.87996Z",
    fill: "#3DB72D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.5 14.1667C8.22667 14.1667 8 13.94 8 13.6667V2.44666C8 2.17332 8.22667 1.94666 8.5 1.94666C8.77333 1.94666 9 2.17332 9 2.44666V13.6667C9 13.94 8.77333 14.1667 8.5 14.1667Z",
    fill: "#3DB72D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow_up.3664b1d35924b28a92d38a9dc06e84de.svg";
export { ForwardRef as ReactComponent };